<template>
  <div class="invitation">
    <div class="dd-main">
      <img class="shard shard--a" :src="shardImg" alt="" />
      <img class="shard shard--b" :src="shardImg" alt="" />
      <img class="shard shard--c" :src="shardImg" alt="" />
      <img class="shard shard--d" :src="shardImg" alt="" />

      <div class="invite-hero">
        <div class="invite-back" @click="onClickLeft">
          <van-icon name="arrow-left" />
        </div>
        <div class="invite-hero__title">推荐好友</div>
        <div class="invite-hero__subtitle">领取黄金碎片</div>
        <div class="invite-hero__pill">邀好友 · 拿奖励 · 共创美好未来</div>
      </div>

      <div class="invite-code-bar">
        <span class="yqm-label">{{ $t("m.yq_span0") }}</span>
        <span class="yqm-code">{{ data.invite }}</span>
        <button type="button" class="copy" @click="copyText(data.invite)">
          复制
        </button>
      </div>

      <div class="ercode" v-if="qrCode">
        <img :src="qrCode" alt="" />
      </div>

      <div class="yqm1">
        <button type="button" class="download-btn" @click="tiaozhuan(1)">
          点击下载
        </button>
        <div class="yqm1-tip">使用浏览器扫描二维码下载app</div>
      </div>

      <div class="lottery-rule">
        <div class="lottery-rule__badge">
          <span>✦</span>
          邀请奖励规则
          <span>✦</span>
        </div>
        <div class="lottery-rule__summary">
          已邀请直推 <b>{{ data.direct_invite_count || 0 }}</b> 人　剩余抽奖
          <b>{{ data.lottery_chances || 0 }}</b> 次
        </div>
        <div
          class="lottery-rule__row"
          v-for="item in rewardRows"
          :key="item.no"
        >
          <div class="row-no">{{ item.no }}</div>
          <div class="row-text">
            累计邀请 <b>{{ item.people }}</b> 人 注册
            获得 <strong>{{ item.times }}</strong> 次 黄金碎片抽取机会
          </div>
          <div class="row-icon">
            <img :src="shardImg" alt="" />
          </div>
        </div>
        <div class="lottery-rule__tip" @click="goLottery">
          <span class="tip-horn">📢</span>
          达到对应邀请人数后，可进入黄金碎片抽取页面参与抽取。
        </div>
      </div>

      <div class="invite-footer">同心同行 共创美好未来</div>
    </div>
  </div>
</template>

<script>
import { getHyDataInfo } from "@api/user";
import QRCode from "qrcode";

export default {
  data() {
    return {
      data: {},
      qrCode: "",
      type: 1,
      shardImg: require("@/assets/images/invite/gold-shard.png"),
      rewardRows: [
        { no: "01", people: 10, times: 1 },
        { no: "02", people: 50, times: 2 },
        { no: "03", people: 100, times: 3 }
      ]
    };
  },

  created() {
    this.getData();
  },

  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    goLottery() {
      this.$router.push("/user/zhuanpan");
    },

    async tiaozhuan(index) {
      this.type = index;

      let url = "";

      switch (index) {
        case 1:
          url = this.data.app_android_url;
          break;
        case 2:
          url = this.data.app_ios_url1;
          break;
        case 3:
          url = this.data.app_ios_url2;
          break;
      }

      if (!url) {
        this.qrCode = "";
        return;
      }

      try {
        this.qrCode = await QRCode.toDataURL(url, {
          width: 300,
          margin: 2
        });
      } catch (e) {
        console.error("二维码生成失败：", e);
        this.qrCode = "";
      }
    },

    getData() {
      getHyDataInfo().then(res => {
        this.data = res.data.data;
        this.tiaozhuan(1);
      });
    },

    copyText(text) {
      var element = this.createElement(text);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand("copy");
      element.remove();
      this.$toast.success("您成功复制了" + text);
    },

    createElement(text) {
      var isRTL = document.documentElement.getAttribute("dir") === "rtl";
      var element = document.createElement("textarea");

      element.style.fontSize = "12pt";
      element.style.border = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      element.style.position = "absolute";
      element.style[isRTL ? "right" : "left"] = "-9999px";

      let yPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      element.style.top = `${yPosition}px`;
      element.setAttribute("readonly", "");
      element.value = text;

      document.body.appendChild(element);

      return element;
    }
  }
};
</script>

<style lang="less">
.invitation {
  width: 100%;
  min-height: 100vh;
  position: relative;
  z-index: 999;
  background: #c62828;
}

.dd-main {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 88px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(120% 60% at 50% 8%, rgba(255, 210, 90, 0.28), transparent 55%),
    radial-gradient(80% 40% at 80% 20%, rgba(255, 255, 255, 0.16), transparent 50%),
    linear-gradient(180deg, #3b18c8 0%, #6a20e4 22%, #d32b3a 48%, #e53935 100%);
}

.shard {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}

.shard--a {
  width: 64px;
  top: 72px;
  left: -10px;
  transform: rotate(-18deg);
  opacity: 0.92;
}

.shard--b {
  width: 42px;
  top: 86px;
  right: -6px;
  transform: rotate(22deg);
  opacity: 0.9;
}

.shard--c {
  width: 36px;
  top: 258px;
  right: 10px;
  transform: rotate(-12deg);
  opacity: 0.85;
}

.shard--d {
  width: 34px;
  top: 268px;
  left: 8px;
  transform: rotate(28deg);
  opacity: 0.85;
}

.invite-hero {
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 14px 48px 16px;
  padding-top: calc(22px + env(safe-area-inset-top));
  box-sizing: border-box;
  text-align: center;
  color: #fff;
}

.invite-back {
  position: absolute;
  left: 12px;
  top: calc(18px + env(safe-area-inset-top));
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  z-index: 5;
}

.invite-hero__title,
.invite-hero__subtitle {
  font-weight: 800;
  letter-spacing: 1px;
  color: #ffe566;
  text-shadow: 0 2px 0 #c9a227, 0 8px 16px rgba(255, 196, 60, 0.35);
}

.invite-hero__title {
  font-size: 34px;
  line-height: 1.1;
  padding: 18px 40px 0;
}

.invite-hero__subtitle {
  margin-top: 4px;
  font-size: 28px;
  line-height: 1.15;
}

.invite-hero__pill {
  display: inline-block;
  margin-top: 12px;
  padding: 6px 16px;
  border-radius: 20px;
  background: #9b1c28;
  font-size: 12px;
  color: #fff;
}

.invite-code-bar {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 36px 0;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #fff;

  .yqm-label {
    font-size: 13px;
    opacity: 0.9;
  }

  .yqm-code {
    font-size: 20px;
    font-weight: 800;
    color: #ffe566;
    margin: 0 8px;
    letter-spacing: 0.5px;
  }

  .copy {
    border-radius: 12px;
    padding: 3px 10px;
    color: #7a4a00;
    font-size: 12px;
    font-weight: 700;
    background: #ffd54a;
    border: 0;
  }
}

.ercode {
  position: relative;
  z-index: 3;
  width: 148px;
  margin: 14px auto 0;
  padding: 8px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 22px rgba(40, 0, 20, 0.22);

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 8px;
  }
}

.yqm1 {
  font-size: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 40px 4px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.92);
  position: relative;
  z-index: 3;
}

.download-btn {
  width: 100%;
  height: 44px;
  margin-bottom: 8px;
  border: 0;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffd86a 0%, #f0b429 100%);
  color: #7a3b00;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 6px 14px rgba(180, 80, 0, 0.28);
}

.yqm1-tip {
  text-align: center;
  line-height: 1.4;
}

.lottery-rule {
  position: relative;
  z-index: 3;
  margin: 18px 18px 0;
  box-sizing: border-box;
  padding: 18px 14px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.94);
  color: #333;
  font-size: 13px;
  line-height: 1.6;
  box-shadow: 0 3px 12px rgba(160, 20, 50, 0.16);
}

.lottery-rule__badge {
  width: max-content;
  max-width: 100%;
  margin: -28px auto 10px;
  padding: 6px 18px;
  border-radius: 16px;
  background: #e53935;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 4px 10px rgba(229, 57, 53, 0.35);

  span {
    margin: 0 6px;
    color: #ffe27a;
  }
}

.lottery-rule__summary {
  margin-bottom: 8px;
  color: #777;
  text-align: center;
  font-size: 12px;
}

.lottery-rule__summary b,
.row-text b,
.row-text strong {
  color: #e53935;
}

.lottery-rule__row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f6eeee;
}

.lottery-rule__row:last-of-type {
  border-bottom: 0;
}

.row-no {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-right: 8px;
  border-radius: 50%;
  background: #e53935;
  color: #fff;
  font-size: 10px;
  line-height: 22px;
  text-align: center;
  font-weight: 700;
}

.row-text {
  flex: 1;
  font-size: 12px;
  line-height: 1.45;
  color: #444;
}

.row-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  margin-left: 6px;
  border-radius: 50%;
  background: #fff6e4;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}

.lottery-rule__tip {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff0ef;
  color: #c62828;
  font-size: 11px;
  display: flex;
  align-items: flex-start;
}

.tip-horn {
  margin-right: 4px;
}

.invite-footer {
  position: relative;
  z-index: 3;
  padding: 16px 0 8px;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: 15px;
  font-style: italic;
  letter-spacing: 1px;
}
</style>
